const data = {
    title: '4.10. Analyse ruimte',
    content: <>
        <p>De aspecten landschap, cultuurhistorie en ruimtelijke kwaliteit zijn voor deze beoordeling samengebracht tot één criterium ‘ruimte’ en niet afzonderlijk beschouwd. De analyse en beoordeling van wind- en zonne-energie komen achtereenvolgens aan bod. Aan het eind van dit hoofdstuk volgt een beschouwing over ‘toetsen versus ontwerpen’ als opmaat naar de alternatiefontwikkeling. </p>
    </>,
    prev: '/energietransitie-05-05-2022/4/9',
    next: '/energietransitie-05-05-2022/4/10/1',
    
}

export default data